import React, { useState, useEffect } from 'react';
import {
  Box,
  // Button,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  MenuItem,
} from '@material-ui/core';
import Spinner from '../../common/Spinner/Spinner';
import { Button } from "../../common/Button/Button"
import { toast } from "react-toastify";
import FormModalCompliance from './FormModalCompliance';

export default function PersonaDetailComplianceTab({ value, index, title, userCompliancePersonalDetails, handleSubmitPersonaDetails, isPersonaLoading, isPersonaFormOpen, setIsPersonaFormOpen, selectedResourceInstanceId, handleFormCancel, setIsFormOpen, isFormOpen, uniqueComplianceInstanceId, handleUpdatePersonaDetail, complianceAlreadyFilledPersonaInstanceId, resourcesDetails, isTestimonialScreen }) {
  // const [isFormOpen, setIsFormOpen] = useState(false);
  const [formData, setFormData] = useState({
    "nResourceInstanceId": "",
    "Shop Act": '',
    "Udyam Registration": '',
    "GST": '',
    "FSSAI registration": '',
    "FSSAI license": '',
    "Cashflow Management": '',
    "Other": ''
  });

  const [isEdit, setIsEdit] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [compliancesResourcesOfUser, setCompliancesResourcesOfUser] = useState([])
  const [selectedInstanceResourceId, setSelectedInstanceResourceId] = useState(null);
  const [leftResourcesForAddingPersona, setLeftResourcesForAddingPersona] = useState([]);
  const [allResourcePersonaDetails, setAllResourcePersonaDetails] = useState([]);

  // useEffect to use the resoyurces availed by the user, here uson it for disabling of the add persona details button, if there isnt any for that category
  useEffect(() => {
    if (resourcesDetails?.Compliances) {
      setCompliancesResourcesOfUser(resourcesDetails.Compliances);

      let allCompliances = resourcesDetails?.Compliances;
      console.log(allCompliances, ">>>>>allCompliances")
      let fillingDefaultDataInPersonaDetails = allCompliances.map((resourceObj) => {
        // checking if persona details exist for the instanceId if exists spread it with resource details and if not set default empty keys
        let findPersonaForInstanceId = userCompliancePersonalDetails?.find((personaObj) => personaObj?.nResourceInstanceId == resourceObj?.nResourceInstanceId);
        if (findPersonaForInstanceId) {
          return {
            ...findPersonaForInstanceId,
            ...resourceObj,
            "isAlreadyPersonaExisting": true, // if persona already existitng then flag for all persona to show edit button
          }
        } else {
          return {
            "nResourceInstanceId": "",
            "Shop Act": '',
            "Udyam Registration": '',
            "GST": '',
            "FSSAI registration": '',
            "FSSAI license": '',
            "Cashflow Management": '',
            "Other": '',
            "isAlreadyPersonaExisting": false, // if persona not already existitng then flag for all persona to show add button
            ...resourceObj,
          }
        }
      })

      setAllResourcePersonaDetails([...fillingDefaultDataInPersonaDetails])


      console.log(userCompliancePersonalDetails, ">>>>userCompliancePersonalDetails in compliance useEffect")
      console.log(uniqueComplianceInstanceId, ">>>>uniqueComplianceInstanceId");

      const alreadyFilledPersonaResourceIds = userCompliancePersonalDetails?.map((obj) => {
        const { nResourceInstanceId } = obj;
        return nResourceInstanceId;
      })
      console.log(alreadyFilledPersonaResourceIds, ">>>alreadyFilledPersonaResourceIds compliance");

      if (alreadyFilledPersonaResourceIds) {
        const personaDetailResourceAddingLeft = uniqueComplianceInstanceId?.filter((resourceId) => !alreadyFilledPersonaResourceIds.includes(resourceId))
        console.log(personaDetailResourceAddingLeft, ">>>>personaDetailResourceAddingLeft");
        setLeftResourcesForAddingPersona(personaDetailResourceAddingLeft);
      }
    } else {
      setCompliancesResourcesOfUser([]);
    }
    // setLoading(false);
  }, [resourcesDetails, uniqueComplianceInstanceId, userCompliancePersonalDetails]);

  if (value !== index) return null;

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    if (name == "nResourceInstanceId") {
      let selectedInstanceResourceDetail = compliancesResourcesOfUser.find((obj) => obj.nResourceInstanceId == value);
      console.log(selectedInstanceResourceDetail, ">>>>selectedInstanceResourceDetail")
      setSelectedInstanceResourceId(selectedInstanceResourceDetail?.sResourceID);
    }

    setFormData({ ...formData, [name]: value });
  };

  const handleFormToggle = () => {
    setIsFormOpen(!isFormOpen);
  };

  const handleAddEditButton = (rowData, action) => {
    if (action === "edit") {
      console.log(rowData, ">>>>rowData on handleEdit market connect");
      const { nResourceInstanceId } = rowData;

      const resourceDetailsSelectedId = compliancesResourcesOfUser.find((obj) => obj.nResourceInstanceId == nResourceInstanceId)
      console.log(resourceDetailsSelectedId, ">>>>resourceDetailsSelectedId")
      setSelectedInstanceResourceId(resourceDetailsSelectedId?.sResourceID);

      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(true);
      setIsModalOpen(true)
    } else if (action === "add") {
      console.log(rowData, ">>>>rowData on handleEdit market connect");
      const { nResourceInstanceId } = rowData;

      const resourceDetailsSelectedId = compliancesResourcesOfUser.find((obj) => obj.nResourceInstanceId == nResourceInstanceId)
      console.log(resourceDetailsSelectedId, ">>>>resourceDetailsSelectedId")
      setSelectedInstanceResourceId(resourceDetailsSelectedId?.sResourceID);

      setIsFormOpen(true);
      setFormData(rowData);
      setIsEdit(false);
      setIsModalOpen(true)
    }

  }

  const handleUpdateButtonClick = (formData) => {
    console.log(formData, ">>>>update form data  market connect");

    if (!formData["nResourceInstanceId"]) {
      toast(String("Resource-ID is required"), {
        autoClose: 5000,
        type: toast.TYPE.ERROR,
      });
      setIsModalOpen(false)
    } else {
      const {
        nResourceInstanceId,
        "Shop Act": shopAct,
        "Udyam Registration": udyamReg,
        GST,
        "FSSAI registration": fssaiReg,
        "FSSAI license": fssaiLic,
        "Cashflow Management": cashflowMan,
        Other,
        ...remFormData
      } = formData

      handleUpdatePersonaDetail({
        "Type": "Compliance",
        "subType": "Compliance",
        "nResourceInstanceId": nResourceInstanceId,
        "fields": {
          "Shop Act": shopAct,
          "Udyam Registration": udyamReg,
          GST,
          "FSSAI registration": fssaiReg,
          "FSSAI license": fssaiLic,
          "Cashflow Management": cashflowMan,
          Other,
        }
      });

      setFormData({
        "nResourceInstanceId": "",
        "Shop Act": '',
        "Udyam Registration": '',
        "GST": '',
        "FSSAI registration": '',
        "FSSAI license": '',
        "Cashflow Management": '',
        "Other": ''
      })
      setIsEdit(false)
      setIsModalOpen(false)
    }
  }

  // form to submit new data
  // const renderForm = () => (
  //   <Box>
  //     {isPersonaLoading && <Spinner className="center-screen" />}
  //     {/* <TextField
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     /> */}
  //     <TextField
  //       select
  //       name="nResourceInstanceId"
  //       label="Resource Instance Id"
  //       value={formData["nResourceInstanceId"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //       SelectProps={{
  //         MenuProps: {
  //           PaperProps: {
  //             style: {
  //               maxHeight: 200, // height of dropdown
  //               width: 300,     // width of dropdown
  //             },
  //           },
  //         },
  //       }}
  //     >
  //       {uniqueComplianceInstanceId.map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="Shop Act"
  //       label="Shop Act"
  //       value={formData["Shop Act"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Provided by deAsra', 'Existing'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="Udyam Registration"
  //       label="Udyam Registration"
  //       value={formData["Udyam Registration"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Provided by deAsra', 'Existing'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="GST"
  //       label="GST"
  //       value={formData["GST"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Provided by deAsra', 'Existing'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="FSSAI registration"
  //       label="FSSAI registration"
  //       value={formData["FSSAI registration"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Provided by deAsra', 'Existing'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       select
  //       name="FSSAI license"
  //       label="FSSAI license"
  //       value={formData["FSSAI license"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     >
  //       {['Provided by deAsra', 'Existing'].map((option) => (
  //         <MenuItem key={option} value={option}>{option}</MenuItem>
  //       ))}
  //     </TextField>

  //     <TextField
  //       name="Other"
  //       label="Other"
  //       value={formData["Other"]}
  //       onChange={handleInputChange}
  //       fullWidth
  //       margin="normal"
  //     />
  //   </Box>
  // );

  // render table to display data
  const renderTable = () => (
    <TableContainer component={Paper} style={{ maxHeight: "405px", overflowY: 'auto' }}>
      <Table stickyHeader>
        <TableHead>
          <TableRow>
            {/* {[
              'Shop Act',
              'Udyam Registration',
              'GST',
              'FSSAI registration',
              'FSSAI license',
              'Other',
              "Resource Id",
            ].map((header) => (
              <TableCell key={header}>{header}</TableCell>
            ))} */}

            <TableCell>Resource Id</TableCell>
            <TableCell>Shop Act</TableCell>
            <TableCell>Udyam Registration</TableCell>
            <TableCell>GST</TableCell>
            <TableCell>FSSAI registration</TableCell>
            <TableCell>FSSAI license</TableCell>
            <TableCell>Cashflow Management</TableCell>
            <TableCell>Other</TableCell>
            {
              !isTestimonialScreen && <TableCell>Action</TableCell>
            }
          </TableRow>
        </TableHead>
        <TableBody>
          {/* {
            userCompliancePersonalDetails ? (
              userCompliancePersonalDetails.map((row, index) => (
                // <TableRow key={index}>
                //   {Object.values(row).map((value, i) => (
                //     <TableCell key={i}>{value}</TableCell>
                //   ))}
                // </TableRow>

                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Shop Act"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Udyam Registration"] ?? "N/A"}</TableCell>
                  <TableCell>{row["GST"] ?? "N/A"}</TableCell>
                  <TableCell>{row["FSSAI registration"] ?? "N/A"}</TableCell>
                  <TableCell>{row["FSSAI license"] ?? "N/A"}</TableCell>
                  <TableCell>{row["Other"] ?? "N/A"}</TableCell>
                  <TableCell><Button onClick={() => handleAddEditButton(row)}>Edit</Button></TableCell>
                </TableRow>
              ))

            ) : <TableRow>
              <TableCell colSpan={8} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          } */}

          {
            allResourcePersonaDetails ? (
              allResourcePersonaDetails.map((row, index) => (
                // <TableRow key={index}>
                //   {Object.values(row).map((value, i) => (
                //     <TableCell key={i}>{value}</TableCell>
                //   ))}
                // </TableRow>

                <TableRow key={index}>
                  <TableCell>{row["nResourceInstanceId"] ?? ""}</TableCell>
                  <TableCell>{row["Shop Act"] ? row["Shop Act"] : ""}</TableCell>
                  <TableCell>{row["Udyam Registration"] ? row["Udyam Registration"] : ""}</TableCell>
                  <TableCell>{row["GST"] ? row["GST"] : ""}</TableCell>
                  <TableCell>{row["FSSAI registration"] ? row["FSSAI registration"] : ""}</TableCell>
                  <TableCell>{row["FSSAI license"] ? row["FSSAI license"] : ""}</TableCell>
                  <TableCell>{row["Cashflow Management"] ? row["Cashflow Management"] : ""}</TableCell>
                  <TableCell>{row["Other"] ? row["Other"] : ""}</TableCell>
                  {
                    !isTestimonialScreen && (
                      <TableCell>
                        {
                          row["isAlreadyPersonaExisting"] ? (
                            <Button onClick={() => handleAddEditButton(row, "edit")}>{"Edit"}</Button>
                          ) : (
                            <Button onClick={() => handleAddEditButton(row, "add")}>{"Add"}</Button>
                          )
                        }
                      </TableCell>
                    )
                  }
                </TableRow>
              ))

            ) : <TableRow>
              <TableCell colSpan={8} align="center">
                No Data Found
              </TableCell>
            </TableRow>
          }
        </TableBody>
      </Table>
    </TableContainer>
  );

  // handleFormSubmit
  const submitCompliancePersonaForm = () => {
    console.log(">>>Submit clicked ");
    const {
      nResourceInstanceId,
      "Shop Act": shopAct,
      "Udyam Registration": udyamReg,
      GST,
      "FSSAI registration": fssaiReg,
      "FSSAI license": fssaiLic,
      "Cashflow Management": cashflowMan,
      Other,
      ...remFormData
    } = formData

    let data = {
      "Type": "Compliance",
      "subType": "Compliance",
      "nResourceInstanceId": nResourceInstanceId,
      "fields": {
        "Shop Act": shopAct,
        "Udyam Registration": udyamReg,
        GST,
        "FSSAI registration": fssaiReg,
        "FSSAI license": fssaiLic,
        "Cashflow Management": cashflowMan,
        Other,
      }
    }

    handleSubmitPersonaDetails(data);

    if (!isPersonaLoading) {
      // handleFormToggle(isPersonaFormOpen);
      setFormData({
        "nResourceInstanceId": "",
        "Shop Act": '',
        "Udyam Registration": '',
        "GST": '',
        "FSSAI registration": '',
        "FSSAI license": '',
        "Cashflow Management": '',
        "Other": ''
      })
      handleFormToggle();
      setIsModalOpen(false)
    }
  }

  const handleCancelForm = () => {
    setIsFormOpen(false);
    setIsEdit(false);
    setFormData({
      "nResourceInstanceId": "",
      "Shop Act": '',
      "Udyam Registration": '',
      "GST": '',
      "FSSAI registration": '',
      "FSSAI license": '',
      "Cashflow Management": '',
      "Other": ''
    })

    setSelectedInstanceResourceId(null);
    setIsModalOpen(false);
  }

  console.log(userCompliancePersonalDetails, ">>>>>userCompliancePersonalDetails in market form");
  console.log(formData, ">>>>>formData");
  console.log(compliancesResourcesOfUser, ">>>>compliancesResourcesOfUser in compliance tab")
  console.log(allResourcePersonaDetails, ">>>>allResourcePersonaDetails in compliances");

  return (
    <Box style={{ padding: '16px' }} className={`${isPersonaLoading && "set-opacity"}`}>
      {isPersonaLoading && <Spinner className="center" />}
      <Typography variant="h6" style={{ fontWeight: 'bold', color: '#6D1B7B' }}>
        {title}
      </Typography>

      {/* {isFormOpen ? renderForm() : renderTable()} */}
      {/* {isPersonaFormOpen ? renderForm() : renderTable()} */}
      {renderTable()}


      {/* <Button
        variant="contained"
        color="primary"
        onClick={handleFormToggle}
        style={{ marginTop: 20, width: '100%' }}
      >
        {isFormOpen ? 'Cancel' : 'Add New Opportunity'}
      </Button> */}
      {/* <Box>
        {
          isFormOpen ?
            // isPersonaFormOpen ?
            <Box display="flex" justifyContent="flex-end" padding="0px 20px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                // onClick={handleFormCancel}
                // onClick={() => setIsFormOpen(false)}
                onClick={() => handleCancelForm()}
                style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Cancel
              </Button>

              {
                !isEdit ? <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={submitCompliancePersonaForm}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Submit
                </Button> : <Button
                  variant="contained"
                  color="primary"
                  // onClick={handleFormToggle}
                  onClick={() => handleUpdateButtonClick(formData)}
                  style={{ marginTop: 20, backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
                >
                  Update
                </Button>
              }

            </Box>
            :
            <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleFormToggle}
                style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
              >
                Add New Persona Detail
              </Button>
            </Box>
          // ""
        }

      </Box> */}

      {/* <Box display="flex" justifyContent="flex-end" padding="0px" style={{ gap: "20px" }}>
        <Button
          variant="contained"
          color="primary"
          // onClick={handleFormToggle}
          onClick={() => setIsModalOpen(true)}
          style={{ marginTop: 20, width: '300px', backgroundColor: "#75287C", color: "#fff", textTransform: "none" }}
          disabled={compliancesResourcesOfUser <= 0 || leftResourcesForAddingPersona.length <= 0}
        >
          Add New Persona Detail
        </Button>
      </Box> */}

      <FormModalCompliance
        open={isModalOpen}
        // onClose={() => setIsModalOpen(false)}
        onClose={() => handleCancelForm()}
        isPersonaLoading={isPersonaLoading}
        formData={formData}
        handleInputChange={handleInputChange}
        uniqueComplianceInstanceId={uniqueComplianceInstanceId}
        isEdit={isEdit}
        handleUpdateButtonClick={handleUpdateButtonClick}
        submitCompliancePersonaForm={submitCompliancePersonaForm}
        complianceAlreadyFilledPersonaInstanceId={complianceAlreadyFilledPersonaInstanceId}
        selectedInstanceResourceId={selectedInstanceResourceId}
      />
    </Box>
  );
}
